module.exports = __webpack_public_path__ + "img/img0.061dde34.jpg";